import { render } from "./AllTasks.vue?vue&type=template&id=2c18c341&scoped=true"
import script from "./AllTasks.vue?vue&type=script&lang=js"
export * from "./AllTasks.vue?vue&type=script&lang=js"

import "./AllTasks.vue?vue&type=style&index=0&id=2c18c341&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c18c341"]])

export default __exports__